import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { work } from '../../data/mock';

const OurWork = () => {
  return (
    <section id="work" className="section" style={{ background: '#FFFFFF' }}>
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-2 w-2 rounded-full" style={{ background: '#2EF5FF' }} />
              <span className="text-xs md:text-sm uppercase tracking-[0.25em] font-medium text-[#12367F]/70">
                Our Work
              </span>
            </div>
            <h2
              className="font-display uppercase text-[#12367F] text-balance max-w-4xl"
              style={{ fontSize: 'clamp(2.25rem, 5.5vw, 5rem)', lineHeight: 0.92 }}
            >
              Our latest campaigns{' '}
              <span style={{ background: '#2EF5FF' }} className="px-2 rounded-md">killing it</span> on social
            </h2>
          </div>
          <a href="/work" className="btn-base btn-outline-dark self-start md:self-end">
            View all work <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {work.map((w) => (
            <div key={w.id} className="work-card group block cursor-default">
              <div className="relative rounded-3xl overflow-hidden aspect-[4/5] bg-[#12367F]/10">
                <img
                  src={w.image}
                  alt={w.title}
                  loading="lazy"
                  className="work-img absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#12367F]/80" />
                <span className="absolute top-4 left-4 text-xs uppercase tracking-wider px-3 py-1 rounded-full bg-white/95 text-[#12367F] font-medium">
                  {w.category}
                </span>
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <p className="font-display uppercase text-3xl md:text-4xl leading-none mb-2">{w.title}</p>
                </div>
                <div className="absolute top-4 right-4 h-10 w-10 rounded-full bg-[#2EF5FF] text-[#12367F] grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight className="h-5 w-5" />
                </div>
              </div>
              <div className="pt-5">
                <p className="text-[#12367F] font-semibold text-lg leading-snug">
                  {w.subtitle}
                </p>
                <p className="mt-3 text-[#12367F]/70 text-sm leading-relaxed line-clamp-3">
                  {w.description}
                </p>
                <div className="mt-5 grid grid-cols-3 gap-3 border-t border-[#12367F]/10 pt-5">
                  {w.metrics.map((m) => (
                    <div key={m.label}>
                      <p className="font-display text-2xl md:text-3xl text-[#12367F] leading-none">{m.value}</p>
                      <p className="text-[11px] uppercase tracking-wider text-[#12367F]/60 mt-1">{m.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurWork;
